export default __webpack_public_path__ + "media/Crowd_left.e4d843c6857d60c548e4626a6a712fb7.svg";